/**
 * Utility functions for generating and formatting application links
 */

/**
 * Get the base URL for the application
 * @returns The base URL (shohnat.app in production, localhost in development)
 */
export const getBaseUrl = (): string => {
  return window.location.hostname === 'localhost' 
    ? window.location.origin 
    : 'https://shohnat.app';
};

/**
 * Generate a connection invite link
 * @param invitationId The invitation ID or code
 * @returns The full invitation link
 */
export const generateInviteLink = (invitationId: string): string => {
  return `${getBaseUrl()}/connect?invitation=${invitationId}`;
};

/**
 * Generate a carrier acceptance link
 * @param code The invitation code
 * @param orgId The organization ID
 * @returns The full carrier acceptance link
 */
export const generateCarrierAcceptLink = (code: string, orgId: string): string => {
  return `${getBaseUrl()}/carrier-accept?code=${code}&org=${orgId}`;
};

/**
 * Format a URL for display (show only the domain and path start)
 * @param url The full URL to format
 * @param maxLength Maximum length of the display text (default: 30)
 * @returns Shortened display version of the URL
 */
export const formatUrlForDisplay = (url: string, maxLength: number = 30): string => {
  try {
    const urlObj = new URL(url);
    const domain = urlObj.hostname;
    const path = urlObj.pathname + urlObj.search;
    
    // Start with domain
    let display = domain;
    
    // Add path if there's room
    if (display.length < maxLength && path !== '/') {
      const remainingLength = maxLength - display.length;
      if (path.length <= remainingLength) {
        display += path;
      } else {
        display += path.substring(0, remainingLength - 3) + '...';
      }
    }
    
    return display;
  } catch (error) {
    // If URL parsing fails, just truncate the string
    return url.length > maxLength ? url.substring(0, maxLength - 3) + '...' : url;
  }
};